import { useCallback, useEffect, useState } from 'react';
import { Send, ExternalLink, MessageSquare } from 'lucide-react';
import { useAgent } from '../hooks/useAgent';

const INTENT_TONE = {
  INTERESTED: 'green', MEETING_PICK: 'green',
  QUESTION: 'blue', OBJECTION: 'amber',
  WRONG_PERSON: 'gray', OOO: 'gray', NEUTRAL: 'gray', UNCLEAR: 'gray',
  UNSUBSCRIBE: 'red',
};

export default function DraftsTab() {
  const { listActions, sendReply } = useAgent();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const data = await listActions({ action: 'drafted', limit: 100 });
      setRows(data.actions);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    }
  }, [listActions]);

  useEffect(() => { load(); }, [load]);

  if (error) return <div className="agent-empty">{error}</div>;
  if (!rows) return <div className="agent-loading">Loading…</div>;
  if (rows.length === 0) {
    return (
      <div className="agent-empty">
        <MessageSquare size={30} style={{ opacity: .4, marginBottom: 8 }} />
        <div>No drafts waiting. Replies the agent drafts will appear here for review.</div>
      </div>
    );
  }

  const send = async (r) => {
    setBusy(r.id);
    try {
      await sendReply(r.conversation_id, r.draft_text);
      await load();
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally { setBusy(null); }
  };

  const openInbox = (r) => { window.location.href = `/inbox?conversation=${r.conversation_id}`; };

  return (
    <div className="agent-section">
      {rows.map((r) => (
        <div key={r.id} className="agent-draft">
          <div className="agent-draft-head">
            <span className={`agent-intent tone-${INTENT_TONE[r.intent] || 'gray'}`}>
              {r.intent || 'REPLY'}
            </span>
            {r.confidence != null && <span className="agent-conf">{r.confidence}% sure</span>}
            <strong className="agent-draft-who">{r.contact_name || 'Unknown contact'}</strong>
            {r.conversation_subject && <span className="agent-draft-subj">· {r.conversation_subject}</span>}
          </div>
          <div className="agent-draft-body">{r.draft_text}</div>
          <div className="agent-draft-actions">
            <button className="agent-btn" onClick={() => openInbox(r)}>
              <ExternalLink size={14} style={{ verticalAlign: '-2px', marginRight: 6 }} />
              Open in inbox
            </button>
            <button className="agent-btn primary" onClick={() => send(r)} disabled={busy === r.id}>
              <Send size={14} style={{ verticalAlign: '-2px', marginRight: 6 }} />
              {busy === r.id ? 'Sending…' : 'Send'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
